// Polyfill for process
if (typeof window !== "undefined") {
  if (!window.process) {
    window.process = {};
  }
  if (!window.process.env) {
    window.process.env = {};
  }
  window.process.env.NODE_ENV = process.env.NODE_ENV || "development";
}
